"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _PublicApp = _interopRequireDefault(require("./PublicApp"));

var _q = _interopRequireDefault(require("q"));

var _createConfigInterface = _interopRequireDefault(require("./createConfigInterface"));

var _PublicUsageTracker2 = _interopRequireDefault(require("pricing-pages-unified-ui/utils/_PublicUsageTracker"));

var _AuthType = require("pricing-pages-unified-ui/constants/AuthType");

var _getPublicPagePath = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getPublicPagePath"));

var _EarlyRequestExperimentActions = require("pricing-pages-unified-ui/actions/EarlyRequestExperimentActions");

var _PublicMetaDataActions = require("pricing-pages-unified-ui/actions/public-only/PublicMetaDataActions");

var publicConfig = (0, _createConfigInterface.default)({
  authType: _AuthType.PUBLIC,
  rootUrl: (0, _getPublicPagePath.default)(),
  tracker: (0, _PublicUsageTracker2.default)(),
  blockingRequests: [_PublicMetaDataActions.fetchPublicMetaData, _EarlyRequestExperimentActions.fetchPublicExperimentTreatmentsFromEarlyRequest],
  defaultHubRoute: '/marketing',
  getPurchaseMotions: function getPurchaseMotions() {
    return _q.default.Promise.resolve().then(function () {
      return {
        metadata: {
          customerCurrencyCode: null,
          productBasedOffers: null,
          parcels: [],
          subscriptionTerms: {},
          merchandiseIdsTreatedAsOwned: []
        },
        purchaseMotionsByLocation: null
      };
    });
  }
});
new _PublicApp.default(publicConfig).start();